var map = {
	"./FigmaDDSSlicePNG1820ef0b0eec94a324ecd38d5d744b9a.png": "b75b",
	"./FigmaDDSSlicePNG29dc6e5320c8e8163f34b17e7c516e14.png": "1584",
	"./FigmaDDSSlicePNG2f1445b1e801217d7ade9344b6d4bd59.png": "f707",
	"./FigmaDDSSlicePNG33135e0a938382b6b6e1631066071644.png": "f691",
	"./FigmaDDSSlicePNG4950b085471e8a1273211662e5aad1eb.png": "dab2",
	"./FigmaDDSSlicePNG51937568735ac8c287d60b8534db068f.png": "5543",
	"./FigmaDDSSlicePNG7542c6c27b4a1c08504f12a765fb799f.png": "83e9",
	"./FigmaDDSSlicePNG8f0ef02f658fdd5b0ed0065ce4bcffcd.png": "1100",
	"./FigmaDDSSlicePNGd32d79bef07d06da1fd79365d74432b3.png": "cf49",
	"./FigmaDDSSlicePNGde11b15f3396bb06a9e8f63a8fa4dff0.png": "22da",
	"./FigmaDDSSlicePNGfd68b32f0343131dd8f047a087ff576a.png": "d072",
	"./logo.png": "3cff",
	"./个人3.png": "467a",
	"./个人3@2x.png": "bfcb",
	"./位图(1).png": "6f9f",
	"./位图(2).png": "538c",
	"./位图(3).png": "6c51",
	"./位图(4).png": "dfda",
	"./位图(5).png": "be21",
	"./位图(6).png": "0944",
	"./位图.png": "173d",
	"./位图@2x(1).png": "7077",
	"./位图@2x(2).png": "209c",
	"./位图@2x(3).png": "3327",
	"./位图@2x(4).png": "a93c",
	"./位图@2x(5).png": "7fe4",
	"./位图@2x(6).png": "b5cc",
	"./位图@2x.png": "56b8",
	"./切片.png": "18b5",
	"./切片@2x.png": "2f35",
	"./形状结合(1).png": "6a1e",
	"./形状结合(2).png": "6a1e7",
	"./形状结合(3).png": "6a1e7a",
	"./形状结合.png": "e462",
	"./形状结合@2x(1).png": "45a0",
	"./形状结合@2x(2).png": "45a09",
	"./形状结合@2x(3).png": "45a09b",
	"./形状结合@2x.png": "6a1e7a5",
	"./编组 5.png": "002c",
	"./编组 5@2x.png": "453b",
	"./编组.png": "171b",
	"./编组@2x.png": "6918"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c80c";